import React, { PureComponent } from 'react'
import { reduxForm, Field } from 'redux-form'
import { Table, Button, Tooltip, OverlayTrigger } from 'react-bootstrap'
import PwkTypeMasterModalPage from '../../../containers/masters/PaperworkType/PwkTypeMasterModalPage'
import IDocCarPagination from '../../commons/iDocCarPagination'
import InputText from '../../commons/form/InputText'
import { permissions } from '../../../constants/backendIds'
import { getFieldsSectionPermissions } from '../../../util/permisionFunctions'
import { handleKeyDown } from '../../../util/utils'
import MapSectionsMasters from '../../../util/map-sections-masters'

class PwkTypesMaster extends PureComponent {
  constructor () {
    super()
    this.state = {
      filter: {
        searchDescription: null,
        searchName: null
      },
      fieldsConfiguration: {
        deletePaperwokTypeMaster: null,
        addPaperwokTypeMaster: null
      }
    }
  }

  componentDidMount () {
    this.props.actions.fetchPaperwokTypesMaster({
      page: 1,
      orderBy: '',
      pageSize: 10
    })
  }

  getSortIcon (column = '') {
    switch (this.props.filter.orderBy) {
      case '+' + column:
        return 'ico-sort-selected-asc'
      case '-' + column:
        return 'ico-sort-selected-desc'
      default:
        return 'ico-sort'
    }
  }

  changeOrder (field) {
    switch (this.props.filter.orderBy) {
      case `+${field}`:
        this.props.actions.fetchPaperwokTypesMaster({ ...this.state.filter, ...this.props.filter, orderBy: `-${field}` })
        break
      default:
        this.props.actions.fetchPaperwokTypesMaster({ ...this.state.filter, ...this.props.filter, orderBy: `+${field}` })
        break
    }
  }

  handleNameChange (searchName) {
    if (this.state.filter.searchName !== searchName) {
      this.setState({ filter: { ...this.state.filter, searchName } })
    }
  }

  handleDescriptionChange (searchDescription) {
    if (this.state.filter.searchDescription !== searchDescription) {
      this.setState({ filter: { ...this.state.filter, searchDescription } })
    }
  }

  searchPwkType () {
    this.props.actions.fetchPaperwokTypesMaster({ ...this.props.filter, ...this.state.filter, page: 1 })
  }

  componentDidUpdate (prevProps) {
    if (this.props.tabConfiguration !== prevProps.tabConfiguration) {
      if (this.props.tabConfiguration && this.props.tabConfiguration.sectionFieldsConfiguration) {
        const fieldKeys = Object.keys(this.state.fieldsConfiguration)
        const permission = getFieldsSectionPermissions(this.props.tabConfiguration.sectionFieldsConfiguration, fieldKeys, permissions.hidden)
        this.setState({ fieldsConfiguration: permission.fieldsConfiguration })
      }
    }
  }

  resetFilters () {
    this.setState({
      filter: {
        searchDescription: null,
        searchName: null
      }
    }, () => { this.searchPwkType() })
  }

  render () {
    const {
      t, pwkTypesList, pagesCount, pwkTypesCount, filter,
      filter: { page },
      actions: { fetchPaperwokTypeMasterInfo, deletePaperwokTypeMaster, fetchPaperwokTypesMaster }
    } = this.props
    const secMapMasters = MapSectionsMasters.find(function (s) { return s.page === 'pwkTypesMasterPage' })
    const tKey = 'MASTERS.'
    const editTooltip = (<Tooltip id="editTooltip">{t(`${tKey}EDIT`)}</Tooltip>)
    const deleteTooltip = (<Tooltip id="deleteTooltip">{t(`${tKey}DELETE`)}</Tooltip>)
    const hasFilters = (this.state.filter.searchName || this.state.filter.searchDescription)
    return (
      <div id="pwkTypesMaster" className="inner-results-panel">
        <div className="section-results-header">
          <div className="section-header-title">
            <OverlayTrigger placement="right" overlay={<Tooltip id="editProductTooltip">{`${t((this.props.hideMenu ? 'GLOBAL.TABLES.SHOW_INNER_MENU' : 'GLOBAL.TABLES.HIDE_INNER_MENU'))}`}</Tooltip>}>
              <a onClick={() => this.props.toogleInnerMenu()} className={this.props.hideMenu ? 'collapseBtn' : 'collapseBtn closeInnerMenu'}><i className={this.props.hideMenu ? 'iDocIcon-Open-inner-menu' : 'iDocIcon-Close-inner-menu'}></i></a>
            </OverlayTrigger>
            <h4>{t(`${secMapMasters.title}`)}</h4>
            { this.state.fieldsConfiguration.addPaperwokTypeMaster && this.state.fieldsConfiguration.addPaperwokTypeMaster.permission > permissions.hidden &&
              <Button
                className="_Btn new"
                onClick={() => fetchPaperwokTypeMasterInfo()}>
                <i className='iDocIcon-add-plus'></i> {t('MASTERS.ADD')}
              </Button>
            }
          </div>
          <div className='filters'>
            <div className="search-form">
              <Field
                component={InputText}
                colWidth={50} // 25, 33, 50, 75, 100 default=25
                name="filters.name"
                controlLabel={t(`${tKey}PWK_TYPES_MASTER.NAME`)}
                placeholder={t(`${tKey}PWK_TYPES_MASTER.NAME`)}
                onInputChange={(value) => this.handleNameChange(value)}
              />
              <Field
                component={InputText}
                colWidth={50} // 25, 33, 50, 75, 100 default=25
                name="filters.description"
                controlLabel={t(`${tKey}PWK_TYPES_MASTER.DESCRIPTION`)}
                placeholder={t(`${tKey}PWK_TYPES_MASTER.DESCRIPTION`)}
                onInputChange={(value) => this.handleDescriptionChange(value)}
              />
              <div className="search-form-actions flexInLine al-R">
                <Button
                  className={'_Btn accept'}
                  onClick={() => this.searchPwkType()}
                  onKeyDown={(e) => handleKeyDown(e)}>
                  <i className="ico-search" />
                  {t(`${tKey}SEARCH_BTN`)}
                </Button>
                <Button
                  className={'_Btn accept stk ' + (hasFilters ? ' ' : 'disabled')}
                  onClick={() => {
                    this.props.initialize({})
                    this.resetFilters()
                  }}
                >
                  <i className="ico-cancel" />
                  {t('MASTERS.RESET_BUTTON')}
                </Button>
              </div>
            </div>
          </div>
        </div>
        <div className='section-results-body'>
          <div className={'searchResoultsContainer'}>
            <div className="table-wrapper" key="table-wrapper">
              {/* table */}
              {(pwkTypesList.length !== 0) &&
                <Table className="editable-table" hover responsive>
                  <thead>
                    <tr>
                      <th onClick={() => { this.changeOrder('name') }}>
                        {t(`${tKey}PWK_TYPES_MASTER.NAME`) + ' '}
                        <i className={this.getSortIcon('name')} />
                      </th>
                      <th onClick={() => { this.changeOrder('description') }}>
                        {t(`${tKey}PWK_TYPES_MASTER.DESCRIPTION`) + ' '}
                        <i className={this.getSortIcon('description')} />
                      </th>
                      <th className='actions'>{t('DOSSIER_COMPONENTS.ACCESSORIES.ACTIONS')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {pwkTypesList && pwkTypesList.map((pwkType, idx) => {
                      return (
                        <tr key={idx}>
                          <td>{pwkType.name}</td>
                          <td>{pwkType.description}</td>
                          <td className='actions'>
                            <div>
                              <OverlayTrigger placement="left" overlay={editTooltip}>
                                <a className='_Btn accept stk o-icn ' onClick={() => fetchPaperwokTypeMasterInfo(pwkType.paperworkTypeId)}>
                                  <i className="iDocIcon-edit" />
                                </a>
                              </OverlayTrigger>
                              { this.state.fieldsConfiguration.deletePaperwokTypeMaster && this.state.fieldsConfiguration.deletePaperwokTypeMaster.permission > permissions.hidden &&
                                <OverlayTrigger placement="left" overlay={deleteTooltip}>
                                  <a className='_Btn cancel stk o-icn ' onClick={() => deletePaperwokTypeMaster(pwkType.paperworkTypeId)}>
                                    <i className="iDocIcon-delete-forever" />
                                  </a>
                                </OverlayTrigger>
                              }
                            </div>
                          </td>
                        </tr>)
                    })}
                  </tbody>
                </Table>
              }
              {(pwkTypesList === null || pwkTypesList === undefined || pwkTypesList.length === 0) &&
            <p className="no_results" >{t(`${tKey}PWK_TYPES_MASTER.RESULTS_NOT_FOUND`)}</p>
              }
              <div className="section-users-footer">
                <nav key={1} className="text-center">
                  <IDocCarPagination
                    id="btn_pag_sales"
                    page={page}
                    pagesCount={pagesCount}
                    totalRows={pwkTypesCount}
                    onSelectAction={(value) => fetchPaperwokTypesMaster({ ...filter, ...this.state.filter, page: value })}
                  />
                </nav>
              </div>
            </div>
          </div>
        </div>
        <PwkTypeMasterModalPage />
      </div>
    )
  }
}

export default reduxForm({
  form: 'listPwkTypesMaster'
})(PwkTypesMaster)
